export enum ProductType {
    BP,
    SEND,
    RCV
}